import React from 'react';

const sectionStyle = { marginBottom: 'var(--space-6)' };
const headingStyle = {
  fontSize: 'var(--text-xl)',
  fontWeight: 600,
  color: 'var(--color-text)',
  margin: '0 0 var(--space-3)',
};
const textStyle = {
  fontSize: 'var(--text-base)',
  color: 'var(--color-text-secondary)',
  lineHeight: 1.7,
  margin: '0 0 var(--space-3)',
};

function Privacy() {
  return (
    <div className="section">
      <div className="section-inner" style={{ maxWidth: 760 }}>
        <h1 style={{ fontSize: 'var(--text-3xl)', fontWeight: 700, margin: '0 0 var(--space-2)' }}>
          Privacy Policy
        </h1>
        <p style={{ ...textStyle, color: 'var(--color-text-muted)', marginBottom: 'var(--space-7)' }}>
          Last updated: 9 July 2026 &middot; Applies to the Tailor website (shop-with-tailor.com)
          and the Tailor Chrome extension
        </p>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>What Tailor does</h2>
          <p style={textStyle}>
            Tailor recommends clothing sizes. To do that, it compares body measurements you choose
            to give us against the size guides published on clothing websites you visit. This
            policy explains exactly what data that involves, where it goes, and what we will never
            do with it.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Data we collect</h2>
          <p style={textStyle}>
            <strong>Account details.</strong> When you sign up we store your email address, your
            chosen username, and a hashed version of your password (we never store the password
            itself).
          </p>
          <p style={textStyle}>
            <strong>Body measurements.</strong> The measurements you enter (such as chest, waist,
            hip, inseam, and height) are stored against your account so recommendations work on
            any site without re-entering them.
          </p>
          <p style={textStyle}>
            <strong>Size guide data.</strong> When the extension finds a size guide on a clothing
            product page, it sends that page's address and the size guide's content to our server
            so the guide can be interpreted and cached. This is data about the shop's product, not
            about you, and it is what lets recommendations appear instantly for the next person.
          </p>
          <p style={textStyle}>
            <strong>Connections.</strong> If you use "Shop for Others", we store which accounts
            have mutually agreed to connect. A connected person only ever sees your recommended
            size and fit direction — never your actual measurements.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>What we do not collect</h2>
          <p style={textStyle}>
            The extension does not track your browsing history. Pages that are not clothing
            product pages are ignored entirely and nothing about them is sent anywhere. We use no
            advertising or analytics trackers.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Third parties</h2>
          <p style={textStyle}>
            <strong>Google Gemini.</strong> New size guides are interpreted by Google's Gemini
            model. Only the size guide content from the shop's page is sent — never your account
            details or measurements.
          </p>
          <p style={textStyle}>
            <strong>MongoDB Atlas.</strong> Our database is hosted on MongoDB Atlas. All data
            listed above is stored there.
          </p>
          <p style={textStyle}>We do not sell, rent, or share your personal data with anyone.</p>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Cookies and local storage</h2>
          <p style={textStyle}>
            We use your browser's local storage to keep you logged in (a signed authentication
            token) and to remember preferences such as dark mode. We set no third-party cookies.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Your choices</h2>
          <p style={textStyle}>
            You can edit or delete your measurements at any time from your account. To delete
            your account and all data associated with it, contact us and we will remove it.
            Tailor is also fully open source under the MIT license — you can self-host the entire
            system so your data never leaves your own server.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Contact</h2>
          <p style={textStyle}>
            Questions or data requests: open an issue on{' '}
            <a
              href="https://github.com/DickonC/shop-with-tailor/issues"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </a>{' '}
            or use the contact details on the repository profile.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
